import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.js'
import cart from './cart.js'
import merchandise from './merchandise.js'
import error from './error.js'
import createPersistedState from "vuex-persistedstate"


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    cart,
    merchandise,
    error,
  },
  plugins: [createPersistedState({
    key: 'KomeguraCart',
    paths: ['cart.cart'],
    storage: window.sessionStorage
  })]
})
